import React, { Component, PropTypes } from 'react';
import { Button, Row, Input, Form } from 'antd';

import cn from 'classnames';

import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import Utils from 'utils/utils';
import callApi from 'helpers/callApi';

import classes from './styles/Login.module.scss';

const FormItem = Form.Item;

class Login extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      collapseMobile: [],
      loginButtonLoading: false,
      selectedPage: 'home',
    };
  }

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      loginButtonLoading: true,
    });

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        callApi({ body: values, url: '/users/login' }).then((res) => {
          Utils.createToken(res.accessToken);
          browserHistory.push('/page');
          // Utils.createToken(res.accessToken);
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={classes.form}>
        <div className={cn('tp-logo-teachpot fa-3x', classes.logo)} />
        <Form onSubmit={this.handleSubmit}>
          <FormItem hasFeedback>
            {getFieldDecorator('email', {
              rules: [
                { type: 'email', message: 'The input is not valid E-mail!' },
                {
                  required: true,
                  message: 'email is required',
                },
              ],
            })(<Input size="large" onPressEnter={this.handleSubmit} placeholder="Email" />)}
          </FormItem>
          <FormItem hasFeedback>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: 'password is required',
                },
              ],
            })(<Input size="large" type="password" placeholder="Password" />)}
          </FormItem>
          <Row className="text-center">
            <Button type="primary" size="large" className={'btn-block'} onClick={this.handleSubmit} loading={this.props.loginLoading}>
              Login
            </Button>
          </Row>
        </Form>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    loginLoading: state.user.userLoginWaiting,
  }),
  {},
)(Form.create({})(Login));
